export const company = {
  name: 'Enervybe',
  tagline: 'Your Enervybe Partner',
  LOGO_URL: 'https://admin.enervybe.net/assets/img/logo.png',
  email: 'support@enervybe.net',
  website: 'https://www.enervybe.net/',
};

export const email = {
  content: {
    greeting: 'Hello',
    paragraphs: [
      'Thank you for reaching out to us. We appreciate you considering our company for your needs.',
      'We will be in touch with you shortly.',
    ],
    closing: 'Best regards',
    signature: 'The Enervybe Team',
  },
  cta: {
    url: 'https://enervybe.net',
    text: 'Learn More',
  },
  footer: {
    socialLinks: [
      { platform: 'Facebook', url: 'https://facebook.com/enervybe' },
      { platform: 'Twitter', url: 'https://twitter.com/enervybe' },
      { platform: 'Instagram', url: 'https://instagram.com/enervybe' },
    ],
    unsubscribe: 'https://enervybe.com/unsubscribe',
  },
  recipientName: 'John Doe',
};

export const htmlContent = `<div class="es-wrapper-color" style="background-color: #eee; padding-top: 20px; padding-bottom: 20px;">
  <table class="es-wrapper" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; padding: 0; margin: 0; width: 100%; height: 100%; background-repeat: repeat; background-position: center top;" width="100%" cellspacing="0" cellpadding="0">
    <tbody>
      <tr style="border-collapse: collapse;">
        <td style="padding: 0; margin: 0;" valign="top">
          <table class="es-content" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; table-layout: fixed!important; width: 100%;" cellspacing="0" cellpadding="0" align="center">
            <tbody>
              <tr style="border-collapse: collapse;"></tr>
              <tr style="border-collapse: collapse;">
                <td style="padding: 0; margin: 0;" align="center">
                  <table class="es-header-body" style="border-bottom: 1px solid #ddd; mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; background-color: #fff; width: 600px;" cellspacing="0" cellpadding="0" align="center" bgcolor="#044767">
                    <tbody>
                      <tr style="border-collapse: collapse;">
                        <td style="margin: 0; padding: 20px;" align="left">
                          <table class="es-left" style="border-collapse: collapse; border-spacing: 0px; float: left; width: 101.108%;" cellspacing="0" cellpadding="0" align="left">
                            <tbody>
                              <tr style="border-collapse: collapse;">
                                <td class="es-m-p0r es-m-p20b" style="padding: 0px; margin: 0px; width: 100%;" align="center" valign="top">
                                  <table style="border-collapse: collapse; border-spacing: 0px; width: 17.5986%; height: 49.7273px;" role="presentation" cellspacing="0" cellpadding="0">
                                    <tbody>
                                      <tr style="border-collapse: collapse; height: 49.7273px;">
                                        <td class="es-m-txt-c" style="padding: 0px; margin: 0px; width: 100%;" align="left">
                                          <h1 style="margin: 0; line-height: 36px; mso-line-height-rule: exactly; font-family: 'open sans','helvetica neue',helvetica,arial,sans-serif; font-size: 36px; font-style: normal; font-weight: bold; color: #fff;">
                                            <img style="display: block; margin-left: auto; margin-right: auto;" src="https://www.enervybe.net/assets/images/logo.png" width="96" height="68">
                                          </h1>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="es-content" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; table-layout: fixed!important; width: 100%;" cellspacing="0" cellpadding="0" align="center">
            <tbody>
              <tr style="border-collapse: collapse;">
                <td style="padding: 0; margin: 0;" align="center">
                  <table class="es-content-body" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; background-color: #fff; width: 600px;" cellspacing="0" cellpadding="0" align="center" bgcolor="#ffffff">
                    <tbody>
                      <tr style="border-collapse: collapse;">
                        <td style="padding: 0; margin: 0; padding-left: 20px; padding-right: 20px; padding-top: 0;" align="left">
                          <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr style="border-collapse: collapse;">
                                <td style="padding: 0; margin: 0; width: 530px;" align="center" valign="top">
                                  <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" role="presentation" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                      <tr style="border-collapse: collapse;">
                                        <td style="padding: 0; margin: 0; padding-top: 10px; padding-bottom: 5px;" align="left">
                                          <p>Hi {{User Name}},</p>
                                          <p>We received a request to reset the password for your Enervybe account. To proceed, please use the following One-Time Password (OTP):</p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="es-content" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; table-layout: fixed!important; width: 100%;" cellspacing="0" cellpadding="0" align="center">
            <tbody>
              <tr style="border-collapse: collapse;">
                <td style="padding: 0; margin: 0;" align="center">
                  <table class="es-content-body" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; background-color: #fff; width: 600px;" cellspacing="0" cellpadding="0" align="center" bgcolor="#ffffff">
                    <tbody>
                      <tr style="border-collapse: collapse;">
                        <td style="padding: 0; margin: 0; padding-top: 5px; padding-left: 20px; padding-right: 20px;" align="left">
                          <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr style="border-collapse: collapse;">
                                <td style="padding: 0; margin: 0; width: 530px;" align="center" valign="top">
                                  <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" role="presentation" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                      <tr style="border-collapse: collapse;">
                                        <td style="margin: 0; padding: 10px;" align="left" bgcolor="#eeeeee">
                                          <table class="cke_show_border" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; width: 500px;" role="presentation" border="0" cellspacing="1" cellpadding="1" align="left">
                                            <tbody>
                                              <tr style="border-collapse: collapse;">
                                                <td style="padding: 0; margin: 0;" width="40%">
                                                  <h4 style="margin: 0; line-height: 120%; mso-line-height-rule: exactly; font-family: 'open sans','helvetica neue',helvetica,arial,sans-serif; font-size: 14px;">Details</h4>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr style="border-collapse: collapse;">
                        <td style="padding: 0; margin: 0; padding-left: 20px; padding-right: 20px;" align="left">
                          <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr style="border-collapse: collapse;">
                                <td style="padding: 0; margin: 0; width: 530px;" align="center" valign="top">
                                  <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" role="presentation" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                      <tr style="border-collapse: collapse;">
                                        <td style="margin: 0; padding: 10px;" align="left">
                                          <table class="cke_show_border" style="border-collapse: collapse; border-spacing: 0px; width: 500px; height: 44px;" role="presentation" border="0" cellspacing="1" cellpadding="1" align="left">
                                            <tbody>
                                              <tr style="border-collapse: collapse; height: 44px;">
                                                <td style="padding: 5px 10px 5px 0px; margin: 0px; width: 188.977px;" align="left" width="40%">
                                                  <p style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none; mso-line-height-rule: exactly; font-family: 'open sans','helvetica neue',helvetica,arial,sans-serif; line-height: 24px; color: #333; font-size: 14px; font-weight: 600;"><strong>Your OTP</strong></p>
                                                </td>
                                                <td style="padding: 5px 0px; margin: 0px; width: 298.841px;" align="left" width="60%">
                                                  <p style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none; mso-line-height-rule: exactly; font-family: 'open sans','helvetica neue',helvetica,arial,sans-serif; line-height: 24px; color: #333; font-size: 14px;">: {{OTP}}</p>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="es-content" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; table-layout: fixed!important; width: 100%;" cellspacing="0" cellpadding="0" align="center">
            <tbody>
              <tr style="border-collapse: collapse;">
                <td style="padding: 0; margin: 0;" align="center">
                  <table class="es-content-body" style="border-collapse: collapse; border-spacing: 0px; background-color: #ffffff; width: 600px; height: 242.023px;" cellspacing="0" cellpadding="0" align="center" bgcolor="#ffffff">
                    <tbody>
                      <tr style="border-collapse: collapse; height: 61.8864px;">
                        <td style="padding: 0; margin: 0; padding-top: 20px; padding-left: 20px; padding-right: 20px;" align="left">
                          <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr style="border-collapse: collapse;">
                                <td style="padding: 0; margin: 0; width: 530px;" align="center" valign="top">
                                  <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" role="presentation" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                      <tr style="border-collapse: collapse;">
                                        <td style="margin: 0; padding: 10px;" align="left" bgcolor="#eeeeee">
                                          <table class="cke_show_border" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; width: 500px;" role="presentation" border="0" cellspacing="1" cellpadding="1" align="left">
                                            <tbody>
                                              <tr style="border-collapse: collapse;">
                                                <td style="padding: 0; margin: 0;" width="80%">
                                                  <h4 style="margin: 0; line-height: 120%; mso-line-height-rule: exactly; font-family: 'open sans','helvetica neue',helvetica,arial,sans-serif; font-size: 14px;">REMARKS</h4>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr style="border-collapse: collapse; height: 180.136px;">
                        <td style="padding: 0; margin: 0; padding-left: 20px; padding-right: 20px; border-bottom: 1px solid #ddd;" align="left">
                          <p>This code is valid for the next 10 minutes. For your security, please do not share this code with anyone.</p>
                          <p>If you didn’t request a password reset or believe this message was sent in error, please ignore it or contact our support team immediately at info@enervybe.net.</p>
                          <p>We’re here to assist you and appreciate your trust in Enervybe.</p>
                          <table style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0;" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr style="border-collapse: collapse;">
                                <td style="padding: 0; margin: 0; width: 530px;" align="center" valign="top">&nbsp;</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="es-footer" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; table-layout: fixed!important; width: 100%; background-color: transparent; background-repeat: repeat; background-position: center top;" cellspacing="0" cellpadding="0" align="center">
            <tbody>
              <tr style="border-collapse: collapse;">
                <td style="padding: 0; margin: 0;" align="center">
                  <table class="es-footer-body" style="mso-table-lspace: 0; mso-table-rspace: 0; border-collapse: collapse; border-spacing: 0; background-color: #fff; width: 600px;" cellspacing="0" cellpadding="0" align="center">
                    <tbody>
                      <tr style="border-collapse: collapse;">
                        <td style="margin: 0px; padding-top: 5px; padding-right: 20px; padding-bottom: 0px;" align="center">&nbsp;</td>
                      </tr>
                      <tr style="border-collapse: collapse;">
                        <td style="margin: 0; padding: 35px 20px 40px 20px;" align="left">
                          <table style="border-collapse: collapse; border-spacing: 0px; height: 47.1818px;" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr style="border-collapse: collapse; height: 47.1818px;">
                                <td style="padding: 0; margin: 0; width: 530px;" align="left" valign="top">
                                  <table style="border-collapse: collapse; border-spacing: 0px; height: 68.4545px; width: 99.7549%;" role="presentation" cellspacing="0" cellpadding="0">
                                    <tbody>
                                      <tr style="border-collapse: collapse; height: 68px;">
                                        <td style="padding: 0px 0px 25px; margin: 0px; width: 100%;" align="left">
                                          <p style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none; mso-line-height-rule: exactly; font-family: 'open sans','helvetica neue',helvetica,arial,sans-serif; line-height: 21px; color: #333; font-size: 14px;"><strong>Regards</strong></p>
                                          <p style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none; mso-line-height-rule: exactly; font-family: 'open sans','helvetica neue',helvetica,arial,sans-serif; line-height: 21px; color: #333; font-size: 14px;">The Enervybe Team</p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>`;